import React from "react";
import styled from "styled-components";

import * as Color from "~/Color";
import * as Layout from "~/Layout";
import * as Messaging from "~/Messaging";

import * as MessengerList from "./MessengerList";

const Style = styled.div`
  & .text-wrap {
    overflow-wrap: break-word;
    word-wrap: break-word;
    word-break: break-word;
    hyphens: auto;
  }

  & .ant-table-cell {
    padding: 0;
  }
`;

export const Component = () => {
  return (
    <Style>
      <Layout.Page.Component all>
        <Layout.Section.Component>
          <Headers.Component />
          <Layout.Section.Container.Component>
            <Layout.Row.Component>
              <Layout.Column.Component
                span={10}
                style={{
                  maxHeight: "80vh",
                  borderRight: `1px solid ${Color.steel()}`,
                }}
              >
                <MessengerList.Component />
              </Layout.Column.Component>
              <Layout.Column.Component
                span={14}
                style={{
                  maxHeight: "80vh",
                  // overflowX: "auto",
                  paddingRight: "1em",
                  paddingLeft: "1em",
                }}
              >
                <Messaging.MessageInteraction.Component />
              </Layout.Column.Component>
            </Layout.Row.Component>
          </Layout.Section.Container.Component>
        </Layout.Section.Component>
      </Layout.Page.Component>
    </Style>
  );
};

export namespace Headers {
  export const Component: React.Fn = () => (
    <Layout.Flex.Component
      align="flex-start"
      justify="center"
      style={{
        padding: "1em",
        borderBottom: `1px solid ${Color.veryWhiteGrey()}`,
        borderBottomRightRadius: "0",
        borderBottomLeftRadius: "0",
      }}
    >
      <Messaging.Search.Component />
    </Layout.Flex.Component>
  );
}
